import { getCountryNameTranslation, LocaleCode } from 'acscp/translations';
import { Country } from 'acscp/api/models/country';

const usingTranslatedNameWithFallback = (countries: Country[], locale: LocaleCode): Country[] => {
    return countries
        .map(c => {
            const translatedName = getCountryNameTranslation(c.code, locale);
            return {
                ...c,
                name: translatedName !== undefined ? translatedName : c.name
            };
        });
};

export const getCountryOptionsList = (countries: Country[], locale: LocaleCode): Array<{ id: string, name: string }> => {
    const translatedCountries = usingTranslatedNameWithFallback(countries, locale);

    translatedCountries.sort((a, b) => a.name.localeCompare(b.name));

    return translatedCountries;
};

export const getCallingCodeOptionsList = (countries: Country[], locale: LocaleCode): Array<{ id: string, callingCodeOption: string }> => {
    const translatedCountries = usingTranslatedNameWithFallback(countries.filter(c => !!c.callingCode), locale);

    translatedCountries.sort((a, b) => a.name.localeCompare(b.name));

    return translatedCountries.map(c => ({
        id: c.id,
        callingCodeOption: `${c.callingCode} (${c.name})`
    }));
};

export const countryRequiresState = (country: Country): boolean => country.stateType !== 'NONE';
